/**
 * Command Center rollout children can never enable their surface unless the
 * parent shell is enabled. Keeping this rule pure makes the kill-switch
 * behavior explicit and independently testable.
 */
export function isCommandCenterChildEnabled(parentEnabled, childEnabled) {
  return Boolean(parentEnabled && childEnabled);
}
